import React from 'react';
import { Box, TabPanel, Tabs } from '@mui/joy';
import Container from './dashboard/Container';

const Dashboard = ({ dataProviderName, filters, reportTitleDefault, reportVisibleDefault = false }) => (
    <Box className="dashboard-menu dashboard-menu-1col" sx={{ marginTop: 0 }}>
        <Tabs orientation="horizontal" size="sm" className="dashboard-tabs">
            <TabPanel value={0} className="dashboard-tab-panel">
                <Container dataProviderName={dataProviderName} filters={filters} reportTitleDefault={reportTitleDefault} reportVisibleDefault={reportVisibleDefault} />
            </TabPanel>
        </Tabs>
    </Box>
);

export default Dashboard;
